import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import SearchParamBox from "./SearchParamBox";
// Requests
import { getWalletTable } from "src/Requests/imePortfolio";
// Utilities
import * as R from "ramda";
// Types
import {
  IWalletSearchParams,
  IWalletTableReport,
} from "src/Interfaces/imePortfolio";

interface IProps {
  refreshFlag: boolean;
}

const WalletTable: React.FC<IProps> = ({ refreshFlag }) => {
  // local states
  const [searchParams, setSearchParams] = React.useState<IWalletSearchParams>(
    {} as IWalletSearchParams,
  );

  const onTablesSearchParamChange = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  return (
    <div className="w-full">
      <SearchParamBox
        onChange={onTablesSearchParamChange}
        searchParam={searchParams}
      />
      <TableTemplate<IWalletSearchParams, IWalletTableReport>
        TableUI={({ reports, onAction, sortingType, setSortingType }) => {
          return (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              refreshFlag={refreshFlag}
              tableBoxClassName="max-h-[700px] overflow-auto"
            />
          );
        }}
        getDataTable={getWalletTable}
        withSort
        searchParameters={searchParams}
      />
    </div>
  );
};

export default WalletTable;
